import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register chart components
ChartJS.register(ArcElement, Tooltip, Legend);

const Chart_page = () => {
  const labels = [
    "Advisory Board",
    "Reserve",
    "Development",
    "Pre Sale",
    "Bounties",
    "Token sale",
  ];
  const percentages = [5, 10, 5, 20, 10, 50];
  const colors = [
    "#80caff",
    "#85e0a3",
    "#ffd966",
    "#ffafa3",
    "#ffc470",
    "#D9B8FF",
  ];

  const data = {
    labels: labels, // Used for tooltip only
    datasets: [
      {
        data: percentages,
        backgroundColor: colors,
        hoverBackgroundColor: colors.map((color) => color + "CC"), // Slightly transparent on hover
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "55%", // Adjust inner hole size
    plugins: {
      legend: {
        display: false, // Hide default legend, using custom legend below
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (tooltipItem) => {
            let label = labels[tooltipItem.dataIndex];
            let value = percentages[tooltipItem.dataIndex];
            return `${label}: ${value}%`;
          },
        },
      },
    },
  };

  return (
    <>
      <div className="chart_text">
        <h2>Token Distribution</h2>
        <p>
          Token distribution refers to the process of allocating and
          distributing tokens within a blockchain ecosystem.
        </p>
        <p>
          When a new blockchain project is launched, a specific number of tokens
          are created, and these tokens are distributed among various
          stakeholders, including founders.
        </p>
      </div>
      <div
        className="canva_piechart"
        style={{
          position: "relative",
          width: "400px",
          height: "328px",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <Doughnut data={data} options={options} className="chart_img" />
      </div>
      <div
        className="canva_lable"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        {labels.map((label, index) => (
          <div
            key={index}
            className="canva_piechart_flex"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "24px",
              height: "max-content",
            }}
          >
            <div
              className="canva_piechart_bar"
              style={{
                width: "1px",
                height: "80px",
                backgroundColor: "#323d75",
                margin: "5px 0",
                borderRadius: "50px",
              }}
            />
            <div
              className="canva_piechart_header"
              style={{
                display: "flex",
                alignItems: "baseline",
                flexDirection: "column",
              }}
            >
              <span className="canva_piechart_head">{percentages[index]}%</span>

              <span
                className="canva_piechart_head_sub"
                style={{
                  color: colors[index],

                  textAlign: "start",
                }}
              >
                {label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Chart_page;
